import { render, staticRenderFns } from "./Sessies.vue?vue&type=template&id=f6bbd03e&"
import script from "./Sessies.vue?vue&type=script&lang=js&"
export * from "./Sessies.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/dev/tafelgasten.outlawz.dev/web/app/themes/expert/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f6bbd03e')) {
      api.createRecord('f6bbd03e', component.options)
    } else {
      api.reload('f6bbd03e', component.options)
    }
    module.hot.accept("./Sessies.vue?vue&type=template&id=f6bbd03e&", function () {
      api.rerender('f6bbd03e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/scripts/vue/Sessies.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/Sessies.vue
// module id = 344
// module chunks = 0